import globalNotification from '../../common/hooks/globalNotification';
import { notificationType } from '../../common/constants/notificationType';
import { apiErrorCode } from '../../utils/vinExtraction';

const KNOWN_CODES = [
    'NOT_ALLOWED',
    'VALIDATION_FAILED',
    'VERSION_CONFLICT',
    'VIN_PROCESSING_DISABLED_BY_ENV',
    'VIN_POLLING_PAUSED',
    'VIN_BATCH_IN_FLIGHT',
    'VIN_NO_ELIGIBLE_CARS',
    'VIN_SNAPSHOT_FAILED',
    'INVALID_RANGE',
    'RANGE_TOO_LONG',
    'INVALID_TIMEZONE',
    'INVALID_ID',
    'BATCH_NOT_FOUND',
    'CAR_NOT_FOUND',
    'VEHICLE_SRC_UNAVAILABLE',
    'VIN_QUEUE_UNAVAILABLE',
    'VIN_RESERVATION_TIMEOUT',
];

// no answer from the API itself: the request never got one, or the gateway in front of the API cut it (a bare
// 502/504 with no code) while the API may still be working on it (SC-QA-40)
const LOST_STATUSES = [502, 504];
export const isLostAnswer = error =>
    !apiErrorCode(error) && (!error?.response || LOST_STATUSES.includes(error.response.status));

/** The page's message for a failed call, by the API's `code`; a generic one for anything unknown or unanswered. */
export const vinErrorText = (t, error) => {
    const code = apiErrorCode(error);

    return t(`errors.${KNOWN_CODES.includes(code) ? code : 'GENERIC'}`);
};

export const notifyVinError = (t, error) =>
    globalNotification.open({ type: notificationType.ERROR, message: vinErrorText(t, error), placement: 'top' });
